"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAnswerToLetter = exports.formatSingleQuestionAnswers = exports.filterSingleSelectMultipleChoiceQuestion = void 0;
var uniq_1 = __importDefault(require("lodash/uniq"));
var isUndefined_1 = __importDefault(require("lodash/isUndefined"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var question_type_enum_1 = require("../constants/question-type.enum");
var models_1 = require("../models");
/**
 * filterSingleSelectMultipleChoiceQuestion
 *
 * @param {Question[]}   questions    - Array of Questions
 * Returns single select multiple choice questions
 */
var filterSingleSelectMultipleChoiceQuestion = function (questions) {
    return questions.filter(function (_a) {
        var type = _a.type, definition = _a.definition;
        return type === question_type_enum_1.QuestionType.MultipleChoice && definition.options.length === 4;
    });
};
exports.filterSingleSelectMultipleChoiceQuestion = filterSingleSelectMultipleChoiceQuestion;
/**
 * formatSingleQuestionAnswers
 *
 * @param {string[][]}   answer    - Array of Item Question Performances answers
 *
 * Returns an array of single select questions answers
 */
var formatSingleQuestionAnswers = function (answer, question) {
    var correctAnswers = !(0, isUndefined_1.default)(question) ? question.definition.correctAnswer : [];
    var answers = (0, uniq_1.default)(answer
        .filter(function (studentAnswer) { return !(0, isEmpty_1.default)(studentAnswer); })
        .map(function (studentAnswer) { return studentAnswer[0]; }));
    return answers.map(function (response) {
        var correctAnswer = correctAnswers.find(function (correctAnswerChoice) { return correctAnswerChoice === response; });
        return new models_1.Answer({
            answer: response,
            percentage: calculatePercentage(getTotalSelected(response, answer), answer.length),
            isCorrect: !(0, isEmpty_1.default)(correctAnswer),
        });
    });
};
exports.formatSingleQuestionAnswers = formatSingleQuestionAnswers;
/**
 * Returns the answer letter formatted
 * @param {number}            value      - answer index
 *
 * @return answer letter formatted for the provided value
 */
var formatAnswerToLetter = function (value) { return String.fromCharCode(97 + value); };
exports.formatAnswerToLetter = formatAnswerToLetter;
/**
 * Returns the percentage based on the provided data, if totalAnswers is 0 it returns 0
 * @param response
 * @param totalAnswers
 */
var calculatePercentage = function (response, totalAnswers) {
    if (response === void 0) { response = 0; }
    if (totalAnswers === void 0) { totalAnswers = 0; }
    return totalAnswers ? (response / totalAnswers) * 100 : 0;
};
/**
 * Returns the total of students who selected a response.
 * @param response
 * @param answers
 */
var getTotalSelected = function (response, answers) {
    return answers.filter(function (studentAnswer) { return !(0, isEmpty_1.default)(studentAnswer) && studentAnswer[0] === response; }).length;
};
